export default "__VITE_ASSET__ee7957e0__"